export const externalRedirect = (url: string) => {
	const relativePath = window.location.pathname + window.location.search;
	sessionStorage.setItem('previousUrl', relativePath);
	window.location.href = url;
};
